/* Versão atual do Sisare Web */
export const APP_VERSION = '1.0.0.3'; // alterar a cada nova publicação/release